export const companyInfo = {
  name: 'SoldaGeo Importações',
  tradingName: 'Máquina de Solda Geomembrana',
  cnpj: '62.017.768/0001-25',
  address: 'Rua Hipólito Gregório Pereira 127, Canasvieiras',
  city: 'Florianópolis',
  state: 'SC',
  zip: '',
  country: 'Brasil',
  phone: '+55 48 91802091',
  whatsapp: '+554891802091',
  email: 'contato@soldageo.com.br',
  facebook: 'https://www.facebook.com/share/17JUHvyQmW/',
  instagram: 'https://www.instagram.com/soldageobrasil/',
  years: 10,
  countries: 1,
  models: 12,
};